import { newConvertPersianDigitsToEnglish } from "./validators";

const numbers = /^(|[0-9]\d*)$/;

const Unseparate = (e) => {
  const text = e?.target?.value?.replaceAll(",", "") || e?.replaceAll(",", "");
  const en = newConvertPersianDigitsToEnglish(text);

  if (numbers.test(en)) {
    return en;
  }
  return "";
};

export default Unseparate;
